import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Modal from "@mui/material/Modal";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CardBody from "components/Card/CardBody.js";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import LoadingOverlay from "react-loading-overlay-ts";
import dayjs from "dayjs";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
import { read, utils } from "xlsx";
import Config from "conFig.js";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const xbcolumn = [
  {
    field: "tendvkdvt",
    headerName: "Đơn vị",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "bienkiemsoat",
    headerName: "Biển kiểm soát",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "tuyenduong",
    headerName: "Tuyến đường",
    width: 220,
    headerAlign: "center",
  },
  {
    field: "benden",
    headerName: "Bến đến",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "giovaoben",
    headerName: "Giờ vào bến",
    width: 220,
    headerAlign: "center",
  },
  {
    field: "gioxuatben",
    headerName: "Giờ xuất bến",
    width: 220,
    headerAlign: "center",
  },
  {
    field: "tenlaixe01",
    headerName: "Lái xe 01",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "cccd01",
    headerName: "CCCD lái xe 1",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "tenlaixe02",
    headerName: "Lái xe 02",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "cccd02",
    headerName: "CCCD lái xe 2",
    width: 180,
    headerAlign: "center",
  },
];
export default function Importbenxe() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(100);
  const [data, setData] = React.useState([]);
  const [dataimport, setDataimport] = React.useState([]);
  const [ngaythang, setNgaythang] = React.useState(dayjs());
  const hiddenFileInput = React.useRef(null);
  const [selectedFiles, setSelectedFiles] = React.useState(undefined);
  const [ngays, setNgays] = React.useState([]);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [disableBT, setDisableBT] = React.useState(true);
  const [openxoa, setOpenxoa] = React.useState(false);
  const [isActive, setActive] = React.useState(false);
  const handleClosexoa = () => {
    setOpenxoa(false);
    getdata();
  };
  const huydulieu = () => {
    setOpenxoa(false);
    setDisableBT(true);
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  const handleButtonClicked = () => {
    setActive(true);
  };
  const handleButtonDone = () => {
    setActive(false);
  };
  let ten = "";
  let ngaycheck = "";
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getdata = () => {
    var ngay =
      ngaythang.$y +
      "-" +
      String(ngaythang.$M + 1).padStart(2, "0") +
      "-" +
      ngaythang.$D;
    var url =
      Config.backend +
      "/api/Donvi/getlenhxuatbentmpngay?ngayxuatben=" +
      ngay +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const checkdata = () => {
    var url =
      Config.backend +
      "/api/Donvi/checklenhxuatbentmpngay?ngayxuatben=" +
      ngaycheck +
      "&username=" +
      username;
    return fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        return data[0].result;
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const excelDateToJSDate = (serial) => {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);
    var fractional_day = serial - Math.floor(serial) + 0.0000001;
    var total_seconds = Math.floor(86400 * fractional_day);
    var seconds = total_seconds % 60;
    total_seconds -= seconds;
    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;
    return (
      date_info.getFullYear() +
      "-" +
      (date_info.getMonth() + 1) +
      "-" +
      date_info.getDate() +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds
    );
  };
  const convertdate = (serial) => {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);
    return (
      date_info.getFullYear() +
      "-" +
      (date_info.getMonth() + 1) +
      "-" +
      date_info.getDate()
    );
  };
  const truocimport = () => {
    dataimport.map((item, i) => {
      if (i > 0 && item["THÔNG TIN XE"] !== "TỔNG:") {
        if (!item["__EMPTY"]) {
          ten = item["THÔNG TIN XE"];
        } else {
          let [laixe1, cccd1] = item["LÁI XE"].split("-");
          let [laixe2, cccd2] = item["__EMPTY_5"].split("-");
          insertdata(
            item["THÔNG TIN XE"],
            ten,
            item["__EMPTY_1"],
            item["__EMPTY_2"],
            excelDateToJSDate(item["THỜI GIAN"]),
            excelDateToJSDate(item["__EMPTY_3"]),
            item["TRẠNG THÁI"],
            item["__EMPTY_4"],
            laixe1.trim(),
            cccd1.trim(),
            laixe2.trim(),
            cccd2.trim(),
            item["SỐ KHÁCH"],
            item["__EMPTY_6"]
          );
        }
      }
    });
  };
  const xoadulieu = () => {
    ngays.map((item) => {
      var url = Config.backend + "/api/Donvi/xoalenhxuatbentmp";
      fetch(url, {
        method: "DELETE",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          ngayxuatben: item,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            console.log("");
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    });
    truocimport();
  };
  const insertdata = (
    bienkiemsoat,
    tendvkdvt,
    tuyenduong,
    benden,
    giovaoben,
    gioxuatben,
    dudieukien,
    khongdudieukien,
    tenlaixe01,
    cccdlaixe01,
    tenlaixe02,
    cccdlaixe02,
    sokhachdi,
    sokhachden
  ) => {
    var url = Config.backend + "/api/Donvi/themlenhxuatbentmp";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        bienkiemsoat: bienkiemsoat,
        tendvkdvt: tendvkdvt,
        tuyenduong: tuyenduong,
        benden: benden,
        giovaoben: giovaoben,
        gioxuatben: gioxuatben,
        dudieukien: dudieukien,
        khongdudieukien: khongdudieukien,
        tenlaixe01: tenlaixe01,
        cccdlaixe01: cccdlaixe01,
        tenlaixe02: tenlaixe02,
        cccdlaixe02: cccdlaixe02,
        sokhachdi: sokhachdi,
        sokhachden: sokhachden,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const selectFiles = (event) => {
    setSelectedFiles(event.target.files);
  };
  const uploadFiles = () => {
    if (selectedFiles.length) {
      const file = selectedFiles[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;
        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
          if (rows.length) {
            setDataimport(rows);
            rows.map((item, i) => {
              if (i > 0 && item["THÔNG TIN XE"] !== "TỔNG:") {
                if (!item["__EMPTY"]) {
                  ten = item["THÔNG TIN XE"];
                } else {
                  if (ngaycheck !== convertdate(item["THỜI GIAN"])) {
                    ngaycheck = convertdate(item["THỜI GIAN"]);
                    checkdata().then((response) => {
                      if (response === 1) {
                        setNgays((oldArray) => [...oldArray, ngaycheck]);
                      }
                    });
                    showNotification1();
                    setDisableBT(false);
                  }
                }
              }
            });
          }
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };
  const xacnhandulieu = () => {
    if (ngays.length > 0) {
      setOpenxoa(true);
    } else {
      truocimport();
    }
  };
  const getfile = () => {
    handleButtonClicked();
    window.location.href = Config.link + "5f894d0e-b852-42d3-a085-37cf38ad81e9";
    handleButtonDone();
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  React.useEffect(() => {
    getdata();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ height: "12vh" }}>
        <FormControl
          style={{ width: "100%", marginTop: "7px", height: "100%" }}
        >
          <div className="row my-3">
            <div className="col-8">
              <label className="btn btn-default p-0">
                <Button
                  color="warning"
                  variant="contained"
                  onClick={handleClick}
                  style={{ height: "25px" }}
                >
                  Chọn file
                </Button>
                <input
                  type="file"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={selectFiles}
                  ref={hiddenFileInput}
                  style={{ display: "none" }}
                />
              </label>
            </div>
            <div className="col-4" style={{ marginTop: 15 }}>
              <FormControl style={{ width: "10%" }}>
                <Button
                  color="error"
                  variant="contained"
                  disabled={!selectedFiles}
                  onClick={uploadFiles}
                  style={{ height: "25px" }}
                >
                  Upload
                </Button>
              </FormControl>
              <FormControl style={{ width: "17%", marginLeft: 10 }}>
                <Button
                  color="success"
                  variant="contained"
                  disabled={disableBT}
                  onClick={xacnhandulieu}
                  style={{ height: "25px" }}
                >
                  Kiểm tra dữ liệu
                </Button>
              </FormControl>
              <FormControl style={{ width: "15%", marginLeft: 10 }}>
                <Button
                  color="warning"
                  variant="contained"
                  onClick={getfile}
                  style={{ height: "25px" }}
                >
                  Tải file mẫu
                </Button>
              </FormControl>
            </div>
          </div>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={12} md={2}>
        <LoadingOverlay active={isActive} spinner={true} text="Vui lòng đợi...">
          <FormControl style={{ width: "100%", marginTop: 3 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Ngày xuất bến"
                value={ngaythang}
                format="DD/MM/YYYY"
                onChange={(newValue) => {
                  setNgaythang(newValue);
                }}
                slotProps={{ textField: { size: "small" } }}
                views={["day", "month", "year"]}
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                  },
                }}
              />
            </LocalizationProvider>
          </FormControl>
        </LoadingOverlay>
      </GridItem>
      <GridItem xs={12} sm={12} md={2}>
        <FormControl style={{ width: "80%", marginLeft: 1, marginTop: 3 }}>
          <Button
            color="primary"
            variant="contained"
            onClick={getdata}
            style={{ height: 30 }}
          >
            Xem dữ liệu
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={data}
            columns={xbcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openxoa}
          onClose={handleClosexoa}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={8}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Xác nhận xóa dữ liệu
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosexoa} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <CardBody>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl style={{ width: "100%", marginLeft: 10 }}>
                        Dữ liệu ngày trong File Import đã có!
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl
                        style={{ width: "30%", marginLeft: 10, marginTop: 10 }}
                      >
                        <Button
                          color="success"
                          variant="contained"
                          onClick={xoadulieu}
                        >
                          Xóa dữ liệu và Import
                        </Button>
                      </FormControl>
                      <FormControl
                        style={{ width: "10%", marginLeft: 10, marginTop: 10 }}
                      >
                        <Button
                          color="warning"
                          variant="contained"
                          onClick={huydulieu}
                        >
                          Hủy
                        </Button>
                      </FormControl>
                    </GridItem>
                  </CardBody>
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Import thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Upload thành công, vui lòng kiểm tra dữ liệu"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
